import { render, staticRenderFns } from "./XSubjectSelect.vue?vue&type=template&id=6427fa6e&"
import script from "./XSubjectSelect.vue?vue&type=script&lang=js&"
export * from "./XSubjectSelect.vue?vue&type=script&lang=js&"
import style0 from "./XSubjectSelect.vue?vue&type=style&index=0&id=6427fa6e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports